import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 30000,
});

export async function getConfig() {
  const { data } = await api.get("/config");
  return data;
}

export async function buscarPacientePorCpf(cpf) {
  const { data } = await api.post("/agendamento/buscar-paciente", { cpf });
  return data;
}

export async function listarEspecialidades({ convenioId = null, particular = false } = {}) {
  const params = {};

  if (convenioId) params.convenio_id = convenioId;
  if (particular) params.particular = true;

  const { data } = await api.get("/agendamento/especialidades", { params });
  return data;
}

export async function listarProfissionais(
  especialidadeId,
  { convenioId = null, particular = false, patientId = null } = {}
) {
  const params = {};

  if (especialidadeId) params.especialidade_id = especialidadeId;
  if (convenioId) params.convenio_id = convenioId;
  if (particular) params.particular = true;
  if (patientId) params.patient_id = patientId;

  const { data } = await api.get("/agendamento/profissionais", { params });
  return data;
}

export async function listarHorarios({ profissionalId, especialidadeId, dataStart = null, dataEnd = null, convenioId = null }) {
  const params = { profissional_id: profissionalId };

  if (especialidadeId) params.especialidade_id = especialidadeId;
  if (dataStart) params.data_start = dataStart;
  if (dataEnd) params.data_end = dataEnd;
  if (convenioId) params.convenio_id = convenioId;

  const { data } = await api.get("/agendamento/horarios", { params });
  return data;
}

export async function confirmarAgendamento(payload) {
  const { data } = await api.post("/agendamento/confirmar", payload);
  return data;
}

export async function validarTokenRemarcacao(token) {
  const { data } = await api.get(`/remarcacao/validar/${token}`);
  return data;
}

export async function confirmarRemarcacao(token, novaDataHora) {
  const { data } = await api.post(`/remarcacao/confirmar`, {
    token,
    nova_data_hora: novaDataHora,
  });
  return data;
}

export async function listarConvenios() {
  const { data } = await api.get("/agendamento/convenios");
  return data;
}

export async function criarPreCadastro(payload) {
  const { data } = await api.post("/agendamento/pre-cadastro", payload);
  return data;
}